type TabsProps = {
    tabs: string[]
    activeTab: number
    setActiveTab: (tab: number) => void
}
export default function Tabs(props:TabsProps){

    return <div className={`matchid-tabs`}>
        {props.tabs.map((tab, index) => {
            return <div key={index} onClick={() => props.setActiveTab(index)} className={`matchid-tab ${props.activeTab === index ? "matchid-tab-active" : ""}`}>
                {tab}
            </div>
        })}

    </div>
}